export default "__VITE_ASSET__DcynndmE__"